const getFormSectionQuestions = async ({ form, locale }: { form: string, locale?: string | string[] }) => {
	try {
		const queryParams = `?form=${form}&language=${locale}`;
		const updatedCall = await fetch(
			process.env.APP_PATH + '/api/clear-choice/get-patient-questions/' + queryParams,
			{
				method: 'GET',
			}
		);

		const updatedData = (await updatedCall.json()) as any;

		return updatedData;
	} catch (error) {
		if (error instanceof Error) {
			console.error(`Failed Loading Form Questions: ${error.message}`);
		}
		return [];
	}
};

export { getFormSectionQuestions };
